/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import React from "react";
import { useStoreDispatch } from "../../../store/hooks";
import { Ioptions } from "../../../components/Shared/Filter/types";

import { useSelector } from "react-redux";
import AddLabel from "../../../components/Administrations/LabelManagements/Labels/AddLabel";
import { setLabelName } from "../../../store/filters/devices/Label/LabelDeviceFilterReducer";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import AssociationNavigation from "../../../components/Shared/Association/AssociationNavigation";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { useLabelConfiguration } from "./hooks";

const LabelConfiguration: React.FC = () => {
  const MAX_LABELS = 0;
  const dispatch = useStoreDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);
  const canManageLabels = permissions?.hasOpCodeGroup("manage_label_management");
  const {
    labelDeleteHandler,
    devicesComponent,
    labelList,
    selectedItem,
    setSelectedItem,
  } = useLabelConfiguration();


  const handleNavItemClick = (item: Ioptions) => {
    dispatch(setLabelName(item));
    setSelectedItem(item);
  };


  return (
    <>
      <div className="flex flex-row flex-nowrap">
        <AssociationNavigation
          searchPlaceholder={"Search labels..."}
          navHeaderName={"Labels"}
          selectedItemIndex={selectedItem}
          isManagePermission={canManageLabels}
          navItems={labelList}
          ShowSearchFilterOnRecordsCount={MAX_LABELS}
          addNavItem={AddLabel}
          confirmDeleteDialogOpener={DIALOGOPENFOR.DELETELABEL}
          deleteConfirmationMessage={"Are you sure you want to delete label"}
          addDialogOpener={DIALOGOPENFOR.ADDLABEL}
          handleNavItemClick={handleNavItemClick}
          deleteNavItemHandler={labelDeleteHandler}
        />
        <div className="flex-1 min-h-[285px] pt-2 ml-3 max-w-[calc(100%-240px)]">
          {devicesComponent}
        </div>
      </div>
    </>
  );
};

export default LabelConfiguration;
